import { OpsTask, OpsTasksCounts, OpsTasksFilters } from 'model/OpsTask';

export interface OpsTasksState {
    tasks: Array<OpsTask>;
    counts: OpsTasksCounts;
    // Last-used filters + pagination, kept so mutations can reconcile list + counts on the same query.
    filters: OpsTasksFilters;
    page: number;
    size: number;
    totalPages: number;
    totalRecords: number;
    status: OpsTasksStatus;
    loading: boolean;
    saving: boolean;
    savedTask?: OpsTask;
    error?: string;
}

export enum OpsTasksStatus {
    Initial,
    Fetching,
    FetchSuccess,
    Saving,
    SaveSuccess,
    Deleting,
    DeleteSuccess,
    UpdatingStatus,
    UpdateStatusSuccess,
    BulkCompleting,
    BulkCompleteSuccess,
    Error
}
